/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M8.25 9H9V2.25a.75.75 0 0 0-1.5 0v4.1893L1.2803.2197A.75.75 0 1 0 .2197 1.2803L6.4393 7.5H2.25a.75.75 0 0 0 0 1.5h6Zm7.5 0H15V2.25a.75.75 0 0 1 1.5 0v4.1893L22.7197.2197a.75.75 0 0 1 1.0606 1.0607L17.5607 7.5H21.75a.75.75 0 0 1 0 1.5h-6ZM9 15H2.25a.75.75 0 0 0 0 1.5h4.1893L.2197 22.7197a.75.75 0 0 0 1.0607 1.0606L7.5 17.5607V21.75a.75.75 0 0 0 1.5 0V15Zm6.75 0H15v6.75a.75.75 0 0 0 1.5 0v-4.1893l6.2197 6.2196a.75.75 0 0 0 1.0606 0 .75.75 0 0 0 0-1.0606L17.5607 16.5H21.75a.75.75 0 0 0 0-1.5h-6Z"
    clipRule="evenodd"
  />,
  'Minimize'
);
